import { makeStyles } from "@material-ui/core";

export const css = makeStyles(() => ({
    buttons_grid: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
    },
}));
